<template>
  <div class="microHouse" :style="{marginBottom:isApp?'85px':'0'}">
    <mainHeader class="mainHeader" @logout="logoutClick" v-if="!isApp"></mainHeader>
    <div class="main" :style="{marginTop:isApp?'0':'55px'}">
      <div class="videoPart">
        <video
          ref="video"
          :src="mp4"
          muted
          loop
          controls="controls"
          poster="./images/videoCover.jpg"
        ></video>
      </div>
      <div class="functionPart"></div>
      <div class="showProducts" v-if="!isApp">
        <div class="title">
          <div class="top"></div>
          <div class="switchList">
            <ul>
              <li
                :class="[activeIndex === 1 ? 'active' : '']"
                @click="showProd(1)"
              >
                <i class="eq"></i><span class="text">灭火设备</span>
              </li>
              <li
                :class="[activeIndex === 2 ? 'active' : '']"
                @click="showProd(2)"
              >
                <i class="safe"></i><span class="text">防护装备</span>
              </li>
              <li
                :class="[activeIndex === 3 ? 'active' : '']"
                @click="showProd(3)"
              >
                <i class="service"></i><span class="text">人/车/服务</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="prod">
          <div :class="['prodList', showMore ? 'more' : '']">
            <div
              class="item"
              v-for="(item, index) in productList[activeIndex]"
              :key="index"
            >
              <img
                :src="item.img"
                class="innerImg"
                @click="goDetail(item.src)"
              />
              <p class="name">{{ item.text }}</p>
            </div>
            <div class="hideBtn" v-if="activeIndex !== 3 && !showMore">
              <span class="show" @click="More()">点击查看更多</span>
            </div>
          </div>
        </div>
      </div>
      <div class="contextUs"></div>
      <div class="goodness"></div>
      <div class="standard">
        <div class="check" @click="check()"></div>
      </div>
      <div class="successExp"></div>
      <div class="fireCar">
        <div class="seeDetail" @click="see()"></div>
      </div>
    </div>
    <backTop class="backTop"></backTop>
    <mainFooter v-if="!isApp"></mainFooter>
    <div class="collocationJump" @click="jumpToCol" v-if="isApp">点击查看建站方案套餐</div>
  </div>
</template>

<script>
import backTop from '../../view/back-top'
import mainHeader from '../../view/header'
import mainFooter from '../../view/footer'
export default {
  components: {
    mainHeader,
    mainFooter,
    backTop
  },
  data () {
    return {
      showMore: false,
      activeIndex: 0,
      mp4: 'https://cdn.zxzx119.com/xuanchuanpian.mp4',
      productList: [
        [
          {
            img: require('./images/prodImgs/zzjyry.jpg'),
            text: '专职救援人员',
            src: ''
          },
          {
            img: require('./images/prodImgs/wxxfc.jpg'),
            text: '微型消防车',
            src: ''
          },
          {
            img: require('./images/prodImgs/xfzzxfw.jpg'),
            text: '消防站装修服务',
            src: ''
          },
          {
            img: require('./images/prodImgs/gfmhq.jpg'),
            text: '干粉灭火器',
            src: '10793'
          },
          {
            img: require('./images/prodImgs/xfstb.jpg'),
            text: '消防手抬泵',
            src: '10694'
          },
          {
            img: require('./images/prodImgs/hjq.jpg'),
            text: '缓降器',
            src: '10695'
          },
          {
            img: require('./images/prodImgs/xfftz.jpg'),
            text: '消防服套装',
            src: '10632'
          },
          {
            img: require('./images/prodImgs/zysxfkqhxq.jpg'),
            text: '正压式消防空气呼吸器',
            src: '10857'
          },
          {
            img: require('./images/prodImgs/fdmj.jpg'),
            text: '防毒面具',
            src: '10827'
          }
        ],
        [
          {
            img: require('./images/prodImgs/gfmhq.jpg'),
            text: '干粉灭火器',
            src: '10793'
          },
          {
            img: require('./images/prodImgs/mht.jpg'),
            text: '灭火毯',
            src: '10268'
          },
          {
            img: require('./images/prodImgs/sq.jpg'),
            text: '水枪',
            src: '10263'
          },
          {
            img: require('./images/prodImgs/sd.jpg'),
            text: '水带',
            src: '10860'
          },
          {
            img: require('./images/prodImgs/bfsxswmhq.jpg'),
            text: '背负式细水雾灭火枪',
            src: '10761'
          },
          {
            img: require('./images/prodImgs/xffsq.jpg'),
            text: '消防分水器',
            src: '10630'
          },
          {
            img: require('./images/prodImgs/xfstb.jpg'),
            text: '消防手抬泵',
            src: '10694'
          },
          {
            img: require('./images/prodImgs/nksjk.jpg'),
            text: '内扣式接口',
            src: '10696'
          },
          {
            img: require('./images/prodImgs/xhsbs.jpg'),
            text: '消火栓扳手',
            src: '10638'
          }
        ],
        [
          {
            img: require('./images/prodImgs/xfqxaqs.jpg'),
            text: '消防轻型安全绳',
            src: '10637'
          },
          {
            img: require('./images/prodImgs/hjq.jpg'),
            text: '缓降器',
            src: '10695'
          },
          {
            img: require('./images/prodImgs/xfftz.jpg'),
            text: '消防服套装',
            src: '10632'
          },
          {
            img: require('./images/prodImgs/xfyf.jpg'),
            text: '消防腰斧',
            src: '10633'
          },
          {
            img: require('./images/prodImgs/zysxfkqhxq.jpg'),
            text: '正压式消防空气呼吸器',
            src: '10857'
          },
          {
            img: require('./images/prodImgs/zyskqhxqbp.jpg'),
            text: '正压式空气呼吸器备瓶',
            src: '10857'
          },
          {
            img: require('./images/prodImgs/fdmj.jpg'),
            text: '防毒面具',
            src: '10827'
          },
          {
            img: require('./images/prodImgs/qgsd.jpg'),
            text: '强光手电',
            src: '10248'
          },
          {
            img: require('./images/prodImgs/fgdxs.jpg'),
            text: '发光导向绳',
            src: '10871'
          }
        ],
        [
          {
            img: require('./images/prodImgs/zzjyry.jpg'),
            text: '专职救援人员',
            src: ''
          },
          {
            img: require('./images/prodImgs/wxxfc.jpg'),
            text: '微型消防车',
            src: ''
          },
          {
            img: require('./images/prodImgs/xfzzxfw.jpg'),
            text: '消防站装修服务',
            src: ''
          }
        ]
      ],
      isApp: false // 是不是在app中显示
    }
  },
  mounted () {
    this.getVideo()//
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 ||
      parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      this.isApp = true
    }
  },
  methods: {
    getVideo () {
      this.utils.get(this.accountUrl + '/adb/getList', { type: 9676 }, resj => {
        this.mp4 = resj.data[0].ad_file
      })
    },
    jumpToCol () {
      if (this.utils.isIphone()) {
        window.webkit.messageHandlers.toMicroStationPage.postMessage('')
      } else {
        window.zxzx.toMicroStationPage()
      }
    },
    showProd (index) {
      this.activeIndex = index
      this.showMore = false
    },
    goDetail (id) {
      if (id !== '') {
        this.$router.push({
          path: '/goodsdetail',
          query: {
            goodsId: id,
            businessId: 26359
          }
        })
      }
    },
    More () {
      this.showMore = true
    },
    check () {
      this.$router.push({
        path: '/standardDetail'
      })
    },
    see () {
      this.$router.push({
        path: '/goodsdetail',
        query: {
          goodsId: 10829,
          businessId: 26359
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
body {
  height: 100%;
  width: 100%;
  background: #f4f4f4;
}
.microHouse {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  font-size: 0;
  /deep/ .mainHeader {
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }
  .main {
    display: inline-block;
    width: 100vw;
    font-size: 0;
    margin-top: 55px;
    .videoPart {
      display: inline-block;
      width: 100%;
      height: 210.5px;
      background: #cccccc;
      video {
        object-fit: fill;
        width: 100%;
        height: 100%;
        // min-width: 1470px;
      }
    }
    .functionPart {
      display: inline-block;
      width: 375px;
      height: 302px;
      background: url("./images/1.jpg") no-repeat center center;
      background-size: cover;
    }
    .showProducts {
      display: inline-block;
      width: 100%;
      margin-bottom: 10px;
      .title {
        display: inline-block;
        width: 100%;
        height: 163.5px;
        margin-bottom: 1.5px;
        .top {
          display: inline-block;
          width: 100%;
          height: 55.5px;
          background: url("./images/2t.jpg") no-repeat center center;
          background-size: cover;
        }
        .switchList {
          height: 108.4px;
          ul {
            display: flex;
            width: 100%;
            height: 100%;
            background: #ffffff;
            li {
              cursor: pointer;
              position: relative;
              width: 100%;
              height: 100%;
              display: inline-block;
              font-size: 15px;
              color: #000000;
              i {
                position: absolute;
                width: 46.5px;
                height: 42px;
                left: calc(50% - 23px);
                top: 11px;
              }
              .eq {
                background: url("./images/eq.png") no-repeat center center;
                background-size: cover;
              }
              .safe {
                background: url("./images/safe.png") no-repeat center center;
                background-size: cover;
              }
              .service {
                background: url("./images/service.png") no-repeat center center;
                background-size: cover;
              }
              .text {
                position: absolute;
                left: 0;
                right: 0;
                margin: 0;
                bottom: 20px;
                text-align: center;
              }
              &::after {
                content: "";
                position: absolute;
                height: 5px;
                width: 0;
                left: 0;
                right: 0;
                margin: 0 auto;
                bottom: 0;
                background: #c41335;
                transition: width 0.5s;
              }
              &.active {
                color: #c41335;
                .eq {
                  background: url("./images/eq_active.png") no-repeat center
                    center;
                  background-size: cover;
                }
                .safe {
                  background: url("./images/safe_active.png") no-repeat center
                    center;
                  background-size: cover;
                }
                .service {
                  background: url("./images/service_active.png") no-repeat
                    center center;
                  background-size: cover;
                }
              }
              &.active::after {
                content: "";
                width: 64px;
                transition: width 0.5s;
              }
            }
          }
        }
      }
      .prod {
        display: inline-block;
        width: 100%;
        background: #ffffff;
        .prodList {
          position: relative;
          display: inline-block;
          width: 100%;
          height: 501px;
          padding: 15px;
          overflow: hidden;
          .item {
            display: inline-block;
            width: 167.5px;
            height: 206px;
            border-radius: 10px;
            margin-bottom: 10px;
            margin-right: 10px;
            .innerImg {
              width: 100%;
              border: 1px solid #eeeeee;
              border-bottom: none;
              border-radius: 10px 10px 0 0;
            }
            .name {
              display: inline-block;
              width: 100%;
              height: 38.5px;
              line-height: 38.5px;
              background: #f9f9f9;
              font-size: 14px;
              color: #000000;
              padding-left: 11px;
              border: 1px solid #eeeeee;
              border-radius: 0 0 10px 10px;
            }
            &:nth-child(2n) {
              margin-right: 0;
            }
          }
          .hideBtn {
            position: absolute;
            width: 100%;
            left: 0;
            bottom: 0;
            height: 55px;
            background: #ffffff;
            text-align: center;
            .show {
              display: inline-block;
              width: 345px;
              height: 40px;
              background: #f9f9f9;
              font-size: 14px;
              color: #000000;
              text-align: center;
              line-height: 40px;
              border: 1px solid #eeeeee;
              border-radius: 10px;
            }
          }
          &.more {
            height: auto;
            overflow: auto;
          }
        }
      }
    }
    .contextUs {
      display: inline-block;
      width: 100%;
      height: 186.9px;
      background: url("./images/2.jpg") no-repeat center center;
      background-size: cover;
    }
    .goodness {
      display: inline-block;
      width: 100%;
      height: 589.5px;
      background: url("./images/3.jpg") no-repeat center center;
      background-size: cover;
    }
    .standard {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 295.5px;
      background: url("./images/4.jpg") no-repeat center center;
      background-size: cover;
      .check {
        position: absolute;
        width: 320px;
        height: 40px;
        bottom: 10px;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }
    .successExp {
      display: inline-block;
      width: 100%;
      height: 469.35px;
      background: url("./images/5.jpg") no-repeat center center;
      background-size: cover;
    }
    .fireCar {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 411.5px;
      background: url("./images/6.jpg") no-repeat center center;
      background-size: cover;
      .seeDetail {
        position: absolute;
        width: 115px;
        height: 35px;
        left: 15px;
        bottom: 20px;
      }
    }
    // <div class="standard">
    //   <div class="check" @click="check()"></div>
    // </div>
    // <div class="successExp"></div>
    // <div class="fireCar">
    //   <div class="seeDetail" @click="see()"></div>
    // </div>
  }
  .collocationJump {
    position: fixed;
    width: calc(100% - 50px);
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 15px;
    font-size: 14px;
    color: #ffffff;
    background: #c41335;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/microFireHouse/index.vue